import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../components/button'
import { Checkbox } from '../../components/inputs/Checkbox'
import { InitiateRefundModal } from '../../components/modal/app_modals/initiateRefundModal'
import { OrderItem } from '../../components/product/orderItem'
import Spinner from '../../components/spinner/Spinner'
import { PageHeader } from '../../components/typography/PageHeader'
import { useModalControl } from '../../hooks/useModalControl'
import Layout from '../../layout'
import { useGetOrderQuery } from '../../redux-toolkits/orders/orders.slice'

export const InitiateRefundPage = () => {
  const { harmonizedReference, orderId } = useParams<{
    harmonizedReference: string
    orderId: string
  }>()

  const [selectedItems, setSelectedItems] = useState<string[]>([])

  const navigate = useNavigate()

  const { data: orderDetails, isFetching: fetchingOrderDetails } =
    useGetOrderQuery(
      {
        id: orderId ?? '',
      },
      { refetchOnMountOrArgChange: true },
    )

  const { modal, modalOpen, handleModalClose, setModalOpen, handleModalOpen } =
    useModalControl()

  return (
    <Layout>
      <div className="mb-10 flex items-center justify-between flex-wrap gap-4">
        <PageHeader title="Initiate Refund" className="!mb-0" />

        <div className="flex items-center gap-4">
          <Button
            type="button"
            label="Continue"
            onClick={() => {
              handleModalOpen('initiateRefundModal')
            }}
            primary
            disabled={selectedItems.length < 1}
            className="!max-w-fit !px-10"
          />

          <Button
            type="button"
            label="Cancel"
            onClick={() => {
              navigate(`/orders/${harmonizedReference}`)
            }}
            primary={false}
            className="!max-w-fit !px-10"
          />
        </div>
      </div>

      {fetchingOrderDetails ? (
        <Spinner fullScreen={false} />
      ) : (
        <div>
          <Checkbox
            checkStatus={
              orderDetails?.data?.orderItems.length === selectedItems.length
            }
            handleChange={(selected) => {
              if (selected) {
                setSelectedItems([
                  ...(orderDetails?.data?.orderItems?.map((item) => item._id) ??
                    []),
                ])
              } else {
                setSelectedItems([])
              }
            }}
            textPosition="right"
            text="Select all items for full refund"
            className="font-medium"
          />
          {/* <p className="font-medium mb-6">Select items for refund</p> */}

          {orderDetails?.data?.orderItems?.map((item, idx) => {
            return (
              <div
                className="border-b cursor-pointer last:border-b-0 flex items-start gap-6 py-6 first:!pt-0 last:!pb-0 only:!pt-0"
                key={`order-item-${idx}`}
                onClick={(e) => {
                  e.preventDefault()

                  const selectedItemsCopy: string[] = JSON.parse(
                    JSON.stringify(selectedItems),
                  )

                  if (selectedItems.includes(item._id)) {
                    setSelectedItems(
                      selectedItemsCopy.filter((t) => t !== item._id),
                    )
                  } else {
                    selectedItemsCopy.push(item._id)
                    setSelectedItems(selectedItemsCopy)
                  }
                }}
              >
                <Checkbox
                  checkStatus={selectedItems.includes(item._id)}
                  handleChange={() => {}}
                />

                <OrderItem item={item} className="!py-0" />
              </div>
            )
          })}
        </div>
      )}

      <InitiateRefundModal
        open={modalOpen && modal === 'initiateRefundModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={() => {
          handleModalClose()
          navigate(`/orders/${harmonizedReference}`)
        }}
        items={selectedItems}
        order={orderDetails?.data?.order}
        orderItems={orderDetails?.data?.orderItems}
        type={
          orderDetails?.data?.orderItems.length === selectedItems.length
            ? 'FULL'
            : 'PARTIAL'
        }
      />
    </Layout>
  )
}
